<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px !important;
 min-width: 1200px;
 height: 100%;
}
.search-con {
  padding: 10px 0;
}
.select_input {
  width: 150px;
  margin-right: 10px;
}
.marg_right10 {
  margin-right: 10px;
}
.ivu-card,.ivu-breadcrumb{font-size: 16px !important;}
.ivu-menu-item{font-size: 16px !important}
.ivu-table,.ivu-btn{
  font-size: 14px !important;
}
.ivu-select-item{
  font-size: 14px !important;
}

.ivu-btn{
  padding: 4px 12px 4px !important;
}
.ivu-btn-small{
  padding: 1px 7px 2px !important;
}
.ivu-steps-content{
word-wrap:break-word !important;
}
.ivu-radio-wrapper{
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue